import { capitalize } from 'lodash';
import { AddToCalendar } from 'components/Appointment/AddToCalendar';
import { ConfirmationBadge } from 'components/Appointment/ConfirmationBadge';
import { formatDate } from 'utils/helpers';

const Item = ({ appointment }) => (
  <div className="flex flex-wrap items-center gap-x-3.5 gap-y-2.5 px-4 py-4 sm:px-5">
    <div className="flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl border border-gray-200 bg-secondary-50/50">
      <span className="text-[10px] font-bold uppercase tracking-wider text-secondary-500">{formatDate(appointment.date, 'MMM')}</span>
      <span className="text-base font-bold leading-none text-secondary-900">{formatDate(appointment.date, 'D')}</span>
    </div>

    <div className="min-w-0 flex-1">
      <p className="text-sm font-bold text-secondary-900">{capitalize(appointment.type) || 'Appointment'}</p>
      <p className="mt-0.5 break-words text-[13px] text-secondary-500">
        {[formatDate(appointment.date, 'dddd'), appointment.startTime, appointment.provider.name].filter(Boolean).join(' · ')}
      </p>
    </div>

    <div className="flex basis-full flex-wrap items-center gap-x-4 gap-y-1.5 pl-[58px] sm:basis-auto sm:pl-0">
      <ConfirmationBadge appt={appointment} />

      <AddToCalendar
        appointment={appointment}
        label="Add to calendar"
        hideIcon
        replaceTrigger
        triggerClassName="cursor-pointer text-[13px] font-semibold text-secondary-700 transition-colors hover:text-teamcare-blue"
        wrapperClassName="group"
        menuClassName="hidden group-focus-within:flex"
      />
    </div>
  </div>
);

export default Item;
